// Moved from `src/features/dictationLogs/buildAppToneMap.ts` (now a re-export
// delegate) at D1 slice 1, ARCFE-1067. Body byte-identical; only the specifiers
// changed — the sibling transform is now relative and the types come from the
// contracts door.
import { type DictationAppCategoryResponse, type DictationTone } from '../contracts';
import { normalizeTone } from './normalizeTone';

/** Flatten categories to an app-identifier → tone map (identifiers verbatim; Rust case-folds). */
export function buildAppToneMap(
  categories: DictationAppCategoryResponse[]
): Record<string, DictationTone> {
  const map: Record<string, DictationTone> = {};
  for (const category of categories) {
    const tone = normalizeTone(category.tone);
    for (const identifier of category.app_identifiers) {
      map[identifier] = tone;
    }
  }
  return map;
}
